export default __webpack_public_path__ + "static/media/Gallery-8.9adacca9.jpg";